import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '60%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '40%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const RemarkFooter = () => {

    return(
        <View style={styles.row}>
            <Text style={styles.description}>Remark:</Text>
            <Text style={styles.total}></Text>
        </View>
    )
};

  export default RemarkFooter
